<template>
  <div style="background-color: #fff; padding: 0 10px 10px 10px">
    <!-- 搜索 -->
    <div ref="topDom" class="header-bar">
      <div class="bar-lef">
        <div class="lef-one">
          <a-select
              v-model:value="searchForm.status"
              allowClear
              placeholder="状态"
              @change="getTableData"
          >
            <a-select-option :value="0">待上报</a-select-option>
            <a-select-option :value="1">上报中</a-select-option>
            <a-select-option :value="2">上报成功</a-select-option>
            <a-select-option :value="3">上报失败</a-select-option>
          </a-select>
        </div>
        <div class="lef-one">
          <a-input
              v-model:value="searchForm.hid"
              allowClear
              class="inp-w-m"
              placeholder="房间ID"
          >
          </a-input>
        </div>
        <div class="lef-one">
          <a-input
              v-model:value="searchForm.order_id"
              allowClear
              class="inp-w-m"
              placeholder="订单ID"
          >
          </a-input>
        </div>
        <div class="lef-one">
          <a-input
              v-model:value="searchForm.tid"
              allowClear
              class="inp-w-m"
              placeholder="入住登记ID"
          >
          </a-input>
        </div>
        <div class="lef-one">
          <a-input-search
              v-model:value="searchForm.keyword"
              :loading="searchLoading"
              placeholder="姓名|手机号|证件号|房间"
              @search="getTableData"
          >
          </a-input-search>
        </div>
        <div class="lef-one-no-shadow">
          <a-button type="link" @click="handleReset">重置筛选</a-button>
        </div>
      </div>
      <div class="bar-rig">
        <div class="rig-one">
          <a-popover
              v-model:visible="visiblePopover"
              placement="bottom"
              trigger="click"
          >
            <template #content>
              <template v-for="(item, index) in initColumns" :key="index">
                <div v-if="item.title" style="margin: 5px 0">
                  <a-checkbox v-model:checked="item.isShow">{{
                      item.title
                    }}
                  </a-checkbox>
                </div>
              </template>
              <a-button
                  size="small"
                  style="margin-right: 5px"
                  @click="handleResetCheck"
              >重置
              </a-button
              >
              <a-button class="btn-primary" size="small" @click="handleCheck"
              >确认
              </a-button
              >
            </template>
            <a-button>
              <appstore-outlined/>
              视图
            </a-button>
          </a-popover>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="searchLoading"
        :pagination="false"
        :scroll="{ x: columns.length > 8 ? columns.length*130 : 0, y: tableHeight }"
        bordered
        class="table"
        size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key == 'order_id'">
          <a-button type="link" @click="detShow = true;orderId = record.order_id;">{{ record.order_id }}</a-button>
        </template>
        <template v-if="column.key == 'status'">
          <span v-if="record.status == 1" class="f-c-red">{{ record.status_text }}</span>
          <span v-else-if="record.status == 2" class="f-c-green">{{ record.status_text }}</span>
          <span v-else class="f-c-red">{{ record.status_text }}</span>
        </template>
        <template v-if="column.key == 'store_id'">
          <span>{{ record.sname }}({{ record.store_id }}})</span>
        </template>
        <template v-if="column.key == 'hid'">
          <span>{{ record.hname }}({{ record.hid }}})</span>
        </template>
      </template>
    </a-table>

    <!-- 分页 -->
    <MyPagination
        :pageTotal="pageTotal"
        @onShowSizeChange="onShowSizeChange"
        @pageChange="pageChange"
    />
    <!-- 订单详情 -->
    <order-details
        v-model:visible="detShow"
        :orderId="orderId"
        @refreshOrderDetails="refresh"
    />
  </div>
</template>

<script>
import {nextTick, onMounted, reactive, toRefs, watch} from "vue";
import {ChangZhouCheckIn,} from "@/api/api";
import {AppstoreOutlined,} from "@ant-design/icons-vue";
import useUtils from "@/hooks/useUtils.js"; //工具库
import store from "@/store/pms/landlord/index";
import OrderDetails from "@/components/pms/landlord/OrderDetails/OrderDetails.vue";

export default {
  components: {
    OrderDetails,
    AppstoreOutlined,
  },
  setup() {
    let {countTable} = useUtils();

    // 搜索
    const search = reactive({
      topDom: "",
      searchLoading: false,
      searchForm: {
        status: [],
        hid: '',
        order_id: '',
        tid: '',
        keyword: "",
        start: 0,
        limit: 20,
      },
      rangePicker: [],
      visiblePopover: false,
      searchList: {
        deposit: {},
        group: {},
        income: {},
        inout: {},
        paytype: {},
        room: {},
        source: {},
        tag: {},
      },
      handleReset() {
        search.searchForm.keyword = "";
        search.searchForm.order_id = "";
        search.searchForm.hid = "";
        search.searchForm.tid = "";
        search.searchForm.status = [];
        table.getTableData();
      },
      handleCheck() {
        table.columns = table.initColumns.filter((item) => {
          return item.isShow;
        });
        search.visiblePopover = false;
      },
      handleResetCheck() {
        table.initColumns.map((item) => {
          item.isShow = true;
        });
        table.columns = JSON.parse(JSON.stringify(table.initColumns));
        search.visiblePopover = false;
      },
    });

    function getColumns() {
      return [
        {title: "记录ID", dataIndex: "id", key: "id", width: 80, isShow: true, align: "center", ellipsis: true},
        {
          title: "门店",
          dataIndex: "store_id",
          key: "store_id",
          width: 150,
          isShow: true,
          align: "center",
          ellipsis: true
        },
        {title: "房间", dataIndex: "hid", key: "hid", width: 150, isShow: true, align: "center", ellipsis: true},
        {
          title: "订单ID",
          dataIndex: "order_id",
          key: "order_id",
          width: 80,
          isShow: true,
          align: "center",
          ellipsis: true
        },
        {title: "登记ID", dataIndex: "tid", key: "tid", width: 80, isShow: true, align: "center", ellipsis: true},
        {title: "状态", dataIndex: "status", key: "status", width: 80, isShow: true, align: "center", ellipsis: true},
        {title: "备注", dataIndex: "remark", key: "remark", width: 200, isShow: true, align: "center", ellipsis: true},
        {
          title: "同步时间",
          dataIndex: "create_time",
          key: "create_time",
          width: 150,
          isShow: true,
          align: "center",
          ellipsis: true
        },
        {
          title: "登记编号",
          dataIndex: "RZRDJBH",
          key: "RZRDJBH",
          width: 100,
          isShow: true,
          align: "center",
          ellipsis: true
        },
        {
          title: "订单编号",
          dataIndex: "RZDJDDBH",
          key: "RZDJDDBH",
          width: 100,
          isShow: true,
          align: "center",
          ellipsis: true
        },
        {
          title: "房源编号",
          dataIndex: "FYDJBH",
          key: "FYDJBH",
          width: 100,
          isShow: true,
          align: "center",
          ellipsis: true
        },
        {
          title: "苏安码",
          dataIndex: "FYTYBM",
          key: "FYTYBM",
          width: 180,
          isShow: true,
          align: "center",
          ellipsis: true
        },
        {
          title: "类型",
          dataIndex: "RZRLX_text",
          key: "RZRLX_text",
          width: 100,
          isShow: true,
          align: "center",
          ellipsis: true
        },
        {title: "姓名", dataIndex: "RZRXM", key: "RZRXM", width: 100, isShow: true, align: "center", ellipsis: true},
        {
          title: "手机号码",
          dataIndex: "RZRSJHM",
          key: "RZRSJHM",
          width: 130,
          isShow: true,
          align: "center",
          ellipsis: true
        },
        {
          title: "证件类型",
          dataIndex: "RZRZJLX_text",
          key: "RZRZJLX_text",
          width: 100,
          isShow: true,
          align: "center",
          ellipsis: true
        },
        {
          title: "入住人证件号码",
          dataIndex: "RZRZJHM",
          key: "RZRZJHM",
          width: 180,
          isShow: true,
          align: "center",
          ellipsis: true
        },
        {
          title: "民族",
          dataIndex: "RZRMZ_text",
          key: "RZRMZ_text",
          width: 80,
          isShow: true,
          align: "center",
          ellipsis: true
        },
        {
          title: "是否未成年人",
          dataIndex: "SFWCNR_text",
          key: "SFWCNR_text",
          width: 100,
          isShow: true,
          align: "center",
          ellipsis: true
        },
        {
          title: "监护人姓名 ",
          dataIndex: "JHRXM",
          key: "JHRXM",
          width: 100,
          isShow: true,
          align: "center",
          ellipsis: true
        },
        {
          title: "监护人手机号码",
          dataIndex: "JHRSJHM",
          key: "JHRSJHM",
          width: 130,
          isShow: true,
          align: "center",
          ellipsis: true
        },
        {
          title: "实际到店时间",
          dataIndex: "SJDDSJ_text",
          key: "SJDDSJ_text",
          width: 150,
          isShow: true,
          align: "center",
          ellipsis: true
        },
        {
          title: "实际离店时间",
          dataIndex: "SJLDSJ_text",
          key: "SJLDSJ_text",
          width: 150,
          isShow: true,
          align: "center",
          ellipsis: true
        },
        {
          title: "登记时间",
          dataIndex: "DJSJ_text",
          key: "DJSJ_text",
          width: 150,
          isShow: true,
          align: "center",
          ellipsis: true
        },
      ];
    }

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableData();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableData();
      },
    });

    // 表格
    const table = reactive({
      currentItem: {},
      tableHeight: "",
      dataSource: [],
      topData: {},
      initColumns: [],
      getTableData() {
        search.searchLoading = true;
        ChangZhouCheckIn(search.searchForm)
            .then((res) => {
              table.dataSource = res.data.list;
              pagination.pageTotal = res.data.count;
              nextTick(() => {
                table.columns = getColumns();
                table.initColumns = getColumns();
              });
              search.searchLoading = false;
            })
            .catch(() => {
              search.searchLoading = false;
            });
      },
      columns: getColumns(),
    });
    // 订单
    const order = reactive({
      detShow: false,
      orderId: "",
      refresh() {
        table.getTableData();
      },
    });
    watch(
        () => store.state.ContentHeight,
        () => {
          table.tableHeight = countTable(search.topDom) - 80;
        }
    );

    onMounted(() => {
      table.getTableData();
      table.tableHeight = countTable(search.topDom) - 80;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(pagination),
      ...toRefs(order),
    };
  },
};
</script>

<style lang="scss" scoped>
.refund {
  .refund-switch {
    display: flex;
    align-items: center;
    cursor: pointer;

    .switch-lef {
      padding: 4px 8px;
      border: 1px solid #f2f2f2;
      border-radius: 6px 0 0 6px;
      width: 100px;
      text-align: center;
    }

    .switch-rig {
      padding: 4px 8px;
      border: 1px solid #f2f2f2;
      border-radius: 0 6px 6px 0;
      width: 100px;
      text-align: center;
    }

    .refundSel {
      background-color: #1890ff;
      color: #fff;
      border: none;
    }
  }
}

.head-box {
  margin-bottom: 10px;
  font-weight: bold;
}

.ant-tabs > .ant-tabs-nav {
  margin: 0 !important;
}

.fRed {
  color: red;
}
</style>
